import { useMemo } from 'react'
import get from 'lodash.get'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const getNormalizedConfig = (item, config) => {
  let value = get(item, config?.accessor) ?? config?.text ?? null
  if (value && ['date', 'pubDate'].includes(config.accessor)) {
    value = dayjs.utc(value).format(config?.format ?? 'MM/DD/YY')
  }
  if (value?.length && config.prependText) {
    value = `${config.prependText}${value}`
  }

  return {
    ...config,
    value
  }
}

const useNormalizedConfig = (item, config) => useMemo(() => getNormalizedConfig(item, config), [item, config])

export default useNormalizedConfig
